
export class JsaStats {
  id = 0
  due_date = ''
  work_order_number = ''
  jsa_type_id: number = 0
  count: number = 0

  constructor() {
  }

  static buildOne(obj: any): JsaStats {
    let target: JsaStats = Object.assign(new JsaStats(), obj)
    return target
  }

  static buildMany(objs: any[]): JsaStats[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(JsaStats.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

